import React, { Component } from "react";

import { Pagination } from "components/Pagination";
import { Spinner } from "components/Spinner";
import { Toolbar, List } from "./components";

import { getCatalogProducts, searchProducts } from "modules/Catalog/actions";

class Catalog extends Component {
  state = {
    currentPage: 1,
    currentCategory: 3,
    catalogProducts: [],
    arrayLength: 0,
    pageLength: 1,
    isLoading: true,
    searchQuery: ""
  };

  componentDidMount = () => {
    let { currentCategory, currentPage } = this.state;
    let { page, category } = this.props.match.params;
    const { updateCatalogState } = this;

    let initialRoute = parseInt(page, 10);
    let initialCategory = parseInt(category, 10);

    initialRoute = isNaN(initialRoute) ? 1 : initialRoute;
    initialCategory = isNaN(initialCategory) ? 3 : initialCategory;

    if (initialRoute !== undefined) {
      currentPage = initialRoute;
      this.setState({ currentPage: initialRoute });
    }

    if (initialCategory !== undefined) {
      currentCategory = initialCategory;
      this.setState({ currentCategory: initialCategory });
    }

    getCatalogProducts(currentCategory, currentPage, updateCatalogState);
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    const { currentPage, currentCategory } = this.state;
    const { updateCatalogState } = this;

    if (
      nextState.currentPage !== currentPage &&
      nextState.currentCategory !== currentCategory
    ) {
      this.setState({ isLoading: true });
      getCatalogProducts(
        nextState.currentCategory,
        nextState.currentPage,
        updateCatalogState
      );
    } else if (nextState.currentPage !== currentPage) {
      this.setState({ isLoading: true });
      getCatalogProducts(
        currentCategory,
        nextState.currentPage,
        updateCatalogState
      );
    } else if (nextState.currentCategory !== currentCategory) {
      this.setState({ isLoading: true });
      getCatalogProducts(
        nextState.currentCategory,
        currentPage,
        updateCatalogState
      );
    }
    return true;
  };

  handleSearchClick = () => {
    const { searchQuery } = this.state;
    const { updateCatalogState } = this;
    if (searchQuery.length > 2) {
      this.setIsLoadingState(true, () =>
        searchProducts(searchQuery, updateCatalogState)
      );
    }
  };

  handleSearchTyping = event => {
    const { value } = event.currentTarget;
    this.setState({ searchQuery: value });
  };

  setIsLoadingState = (newState, callback) => {
    this.setState({ isLoading: newState }, callback());
  };

  updateCatalogState = newState => {
    this.setState({
      catalogProducts: newState.catalogProducts,
      isLoading: newState.isLoading,
      arrayLength: newState.catalogSize,
      pageLength: newState.pageSize
    });
  };

  handlePaginationClick = event => {
    const { page } = event.currentTarget.dataset || event.srcElement.dataset;
    this.setState({ currentPage: page });
  };

  render() {
    const {
      catalogProducts,
      arrayLength,
      pageLength,
      currentCategory,
      currentPage,
      isLoading
    } = this.state;

    const {
      handlePaginationClick,
      handleSearchClick,
      handleSearchTyping
    } = this;

    const catalogProductsLength = catalogProducts.length;

    return (
      <div>
        <Toolbar
          currentPage={currentPage}
          pageLength={pageLength}
          arrayLength={arrayLength}
          handleSearchClick={handleSearchClick}
          handleSearchTyping={handleSearchTyping}
          catalogProductsLength={catalogProductsLength}
        />

        <List
          catalogProducts={catalogProducts}
          catalogProductsLength={catalogProductsLength}
          isLoading={isLoading}
        />

        <Pagination
          currentCategory={currentCategory}
          handleOnClick={handlePaginationClick}
          arrayLength={arrayLength}
          pageLength={pageLength}
        />

        {isLoading ? <Spinner /> : false}
      </div>
    );
  }
}

export default Catalog;



// WEBPACK FOOTER //
// ./src/modules/Catalog/Catalog.jsx